import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Fields, reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Form } from 'react-bootstrap';
import { TextInput, FormErrorMessages, PasswordRulesHint } from 'ecs-react-components/dist/index.es';
import { messages } from './UpdatePasswordForm.i18n';


export const fields = ['oldPwd', 'newPwd', 'confirmNewPwd'];

class UpdatePasswordForm extends Component {
  onUpdatePasswordClick = (values) => {
    const { userName } = this.props;
    const { oldPwd, newPwd, confirmNewPwd } = values;
    this.props.handleUpdatePassword(userName, oldPwd, newPwd, confirmNewPwd);
  };

  getOldPwdTextInputRef = (c) => { this.oldPwdTextInputRef = c; };
  getNewPwdTextInputRef = (c) => { this.newPwdTextInputRef = c; };
  getConfirmNewPwdTextInputRef = (c) => { this.confirmNewPwdTextInputRef = c; };

  renderFields = (fieldsMeta) => {
    const { oldPwd, newPwd, confirmNewPwd, pwdRules, error } = fieldsMeta;
    const getLabel = (f) => f + 'Label';
    if (error) {
      oldPwd.meta.invalid = true;
    }
    return (
      <div>
        <div className="mb-3">
        <Form.Label id={getLabel(oldPwd.input.name)} htmlFor={oldPwd.input.name} data-qa-item="oldPasswordLbl">
          <FormattedMessage {...messages.label.old} />
        </Form.Label>
        <TextInput
          ref={this.getOldPwdTextInputRef}
          type="password"
          field={ oldPwd }
          data-qa-item="oldPasswordInput"
        />
          <FormErrorMessages field={oldPwd}
            ariaDescribedby={getLabel(oldPwd.input.name)}
            customMessage={<FormattedMessage {...messages.error.oldPassword} />}
          />
        </div>
        <div className="mb-3">
        <Form.Label id={getLabel(newPwd.input.name)} htmlFor={newPwd.input.name} data-qa-item="newPasswordLbl">
          <FormattedMessage {...messages.label.new} />
        </Form.Label>
        <TextInput
          ref={this.getNewPwdTextInputRef}
          type="password"
          field={ newPwd }
          data-qa-item="newPasswordInput"
        >
          <span className="understated small password-help" id="ruleHint">
            <PasswordRulesHint rules={pwdRules} intl={this.props.intl}/>
          </span>
          <FormErrorMessages field={newPwd}
            ariaDescribedby={getLabel(newPwd.input.name)}
            customMessage={<FormattedMessage {...messages.error.rules} />}
          />
        </TextInput>
        </div>
        <div className="mb-3">
        <Form.Label id={getLabel(confirmNewPwd.input.name)}
          htmlFor={confirmNewPwd.input.name}
          data-qa-item="confirmNewPasswordLbl"
        >
          <FormattedMessage {...messages.label.confirmNew} />
        </Form.Label>
        <TextInput
          ref={this.getConfirmNewPwdTextInputRef}
          type="password"
          field={ confirmNewPwd }
          data-qa-item="confirmNewPasswordInput"
        />
          <FormErrorMessages field={confirmNewPwd}
            ariaDescribedby={getLabel(confirmNewPwd.input.name)}
          />
        </div>
      </div>
    );
  }

  render() {
    const { handleSubmit, pwdRules, error } = this.props;
    const submitLabel = <FormattedMessage {...messages.updatePassword.label} />;
    return (
              <form onSubmit={handleSubmit(this.onUpdatePasswordClick)}>
                <p className="card-text" data-qa-item="updatePasswordIntro">
                  <FormattedMessage {...messages.intro.label} />
                </p>
                <Fields names={fields}
                  component={this.renderFields}
                  pwdRules={pwdRules}
                  error={error}
                />
                <div className="button-area">
                  <Button
                    bsClass="btn btn-primary"
                    type="submit"
                    onClick={handleSubmit(this.onUpdatePasswordClick)}
                    data-qa-item="logInButton"
                  >
                    { submitLabel }
                  </Button>
                </div>
              </form>
    );
  }
}

UpdatePasswordForm.propTypes = {
  handleUpdatePassword: PropTypes.func.isRequired,
  fields: PropTypes.array.isRequired,
  values: PropTypes.object,
  userName: PropTypes.string,
  pwdRules: PropTypes.object,
  handleSubmit: PropTypes.func,
  error: PropTypes.object,
  intl: PropTypes.object,
};

const reduxFormConfig = {
  form: 'updatepasswordform',
  fields,
};

export default reduxForm(reduxFormConfig)(injectIntl(UpdatePasswordForm));